import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { bookingShape, historyShape } from 'constants/propTypes';
import { FormattedMessage, intlShape } from 'react-intl';
import Modal from 'components/ui/Modal';
import { ConfirmButton, ActionButton } from 'components/ui/Button';
import { ADD_PAYMENT } from 'store/mutations';
import { useManagedMutation } from 'utils/managedHooks';
import { Row } from '../../../components/shared/Layout';
import { StyledResponsiveColumn } from './OverpaidWarningPopup.styles';
import currencySymbols from '../../../constants/currencies';
import { codes, providers, statusShortCode } from 'constants/payment';

const OverpaidWarningPopup = ({ history: { push }, isOverpaid, booking, intl: { formatMessage } }) => {
  const [isOpen, toggleOpen] = useState(isOverpaid);

  const closeModal = () => toggleOpen(false);

  const [addPayment, { loading }] = useManagedMutation(ADD_PAYMENT, {
    variables: {
      bookingReference: booking.reference,
      payments: [
        {
          provider: providers.NONE,
          method: codes.REFUND,
          status: statusShortCode.success,
          currency: booking.currency,
          amount: booking.totalPriceToBePaid,
          reference: `${booking.reference}_${Date.now()}_overpaid`
        }
      ]
    },
    onCompleted: () => {
      push(`/manage/bookings/${booking.reference}/refund-methods?currency=${booking.currency}`);
      closeModal();
    }
  });
  const getMessaging = () => `
    ${formatMessage(
      { id: 'manageBooking.overpaid.firstSubtitle' },
      { overpaidAmount: `${currencySymbols[booking.currency]}${Math.abs(booking.totalPriceToBePaid)}` }
    )}
    ${formatMessage({ id: 'manageBooking.overpaid.secondSubtitle' })}
    `;

  return (
    <Modal isOpen={isOpen} title={<FormattedMessage id="manageBooking.overpaid.message" />} subtitle={getMessaging()} onClose={closeModal}>
      <Row>
        <StyledResponsiveColumn smallScreens={16} bigScreens={7}>
          <ConfirmButton data-cy="refund-or-writeoff" onClick={addPayment} loading={loading}>
            <FormattedMessage id="manageBooking.overpaid.refundOrWriteoff" />
          </ConfirmButton>
        </StyledResponsiveColumn>

        <StyledResponsiveColumn smallScreens={16} bigScreens={4}>
          <ActionButton type="button" data-cy="overpaid-investigate" onClick={closeModal}>
            <FormattedMessage id="manageBooking.overpaid.investigate" />
          </ActionButton>
        </StyledResponsiveColumn>
      </Row>
    </Modal>
  );
};

OverpaidWarningPopup.propTypes = {
  booking: bookingShape,
  isOverpaid: PropTypes.bool,
  history: historyShape,
  intl: intlShape
};

export default OverpaidWarningPopup;
